


// redux/actions/taskAdminActions.js
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DESIGNATIONS_REQUEST = "FETCH_DESIGNATIONS_REQUEST";
export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS";
export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE";

export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

export const FETCH_TASKS_LIST_REQUEST = "FETCH_TASKS_LIST_REQUEST";
export const FETCH_TASKS_LIST_SUCCESS = "FETCH_TASKS_LIST_SUCCESS";
export const FETCH_TASKS_LIST_FAILURE = "FETCH_TASKS_LIST_FAILURE";

export const FETCH_EMPLOYEES_REQUEST = "FETCH_EMPLOYEES_REQUEST";
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";
export const FETCH_EMPLOYEES_FAILURE = "FETCH_EMPLOYEES_FAILURE";

export const CREATE_TASK_SUBMIT_REQUEST = "CREATE_TASK_SUBMIT_REQUEST";
export const CREATE_TASK_SUBMIT_SUCCESS = "CREATE_TASK_SUBMIT_SUCCESS";
export const CREATE_TASK_SUBMIT_FAILURE = "CREATE_TASK_SUBMIT_FAILURE";

const getToken = () => localStorage.getItem("token");

// Fetch Designations
export const fetchDesignations = () => async (dispatch) => {
  dispatch({ type: FETCH_DESIGNATIONS_REQUEST });
  try {
    const { data } = await axios.get(`${BASE_URL}/v1/api/getAllDesignations`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: FETCH_DESIGNATIONS_SUCCESS, payload: data.data || [] });
  } catch (error) {
    dispatch({ type: FETCH_DESIGNATIONS_FAILURE, payload: error.message });
    toast.error("Failed to fetch designations");
  }
};

// Fetch Locations
export const fetchLocations = () => async (dispatch) => {
  dispatch({ type: FETCH_LOCATIONS_REQUEST });
  try {
    const { data } = await axios.get(`${BASE_URL}/v1/api/get-all-locations-admin`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: data.data || [] });
  } catch (error) {
    dispatch({ type: FETCH_LOCATIONS_FAILURE, payload: error.message });
    toast.error("Failed to fetch locations");
  }
};

// Fetch Tasks List
export const fetchTasksList = () => async (dispatch) => {
  dispatch({ type: FETCH_TASKS_LIST_REQUEST });
  try {
    const { data } = await axios.get(`${BASE_URL}/v1/api/get-all-tasks-admin`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: FETCH_TASKS_LIST_SUCCESS, payload: data.data || [] });
  } catch (error) {
    dispatch({ type: FETCH_TASKS_LIST_FAILURE, payload: error.message });
    toast.error("Failed to fetch tasks list");
  }
};

// Fetch Employees by Designation
export const fetchEmployees = (designation) => async (dispatch) => {
  dispatch({ type: FETCH_EMPLOYEES_REQUEST, payload: designation });
  try {
    const { data } = await axios.get(`${BASE_URL}/v1/api/searchEmployeeByLocation?designation=${designation}`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: { designation, employees: data.data || [] } });
  } catch (error) {
    dispatch({ type: FETCH_EMPLOYEES_FAILURE, payload: { designation, error: error.message } });
    toast.error(`Failed to fetch employees for ${designation}`);
  }
};

// Create Task Submit
export const createTaskSubmit = (tasks) => async (dispatch) => {
  dispatch({ type: CREATE_TASK_SUBMIT_REQUEST });
  try {
    const { data } = await axios.post(
      `${BASE_URL}/v1/api/admin/create-task-submit`,
      { tasks },
      { headers: { Authorization: getToken(), "Content-Type": "application/json" } }
    );
    if (data?.meta?.status) {
      dispatch({ type: CREATE_TASK_SUBMIT_SUCCESS });
      toast.success("Tasks submitted successfully");
    } else {
      dispatch({ type: CREATE_TASK_SUBMIT_FAILURE, payload: data?.meta?.message });
      toast.error(data?.meta?.message || "Failed to submit tasks");
    }
  } catch (error) {
    dispatch({ type: CREATE_TASK_SUBMIT_FAILURE, payload: error.message });
    toast.error(error.message || "Error submitting tasks");
  }
};
